import { NumericFormat } from "react-number-format";
import {
  ArrowToLeft,
  ArrowToRightIcon,
  CalendarIconRent,
  ColoredCalender,
  FavoriteIconRent,
  NUSDIcon,
  CheckInIcon,
  CheckOutIcon,
  UserBoxIcon,
  CheckMarkIcon,
  BookingDateIcon,
  UsersIcon,
  CopyIcon,
  Logo,
  NibiruIcon,
} from "../../AssetComponents/Images";
import { PurpleButton } from "../../Components/Buttons/PurpleButton";
import { PickDate } from "../../Components/Reserve/PickDate";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { BlackButton } from "../../Components/Buttons/BlackButton";
import { useState, useSyncExternalStore } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { api } from "../../Components/functions/Api";
import { useEffect } from "react";
import { PropertyImageWithFallback } from "../../Components/Images/PropertyImageWithFallback";
import imageOptimizationService from "../../Services/ImageOptimizationService";
import {
  getIdFromHash,
  truncateWalletAddress,
} from "../../Components/functions/Functions";
import addDays from "date-fns/addDays";
import converter from "number-to-words";
import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import { executeRentalWithWallet } from "../../Components/functions/Contract";
import { Mainnet, Testnet } from "@nibiruchain/nibijs";
import { setConnectModal } from "../../ReduxSlices/ModalSlice";
import { getChatId } from "../../Components/functions/Functions";
import Modal from "react-responsive-modal";
import { RentalItem } from "../../Components/RealEstateProperty/RentalItem";
import { Bounce, Slide } from "react-awesome-reveal";
import Skeleton from "react-loading-skeleton";
import { updateToken } from "../../Components/functions/Functions";
import { updateNFTStore } from "../../ReduxSlices/NFTSlice";
import { GreenButton } from "../../Components/Buttons/GreenButton";

export const ConfirmDetails = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [profile, setProfile] = useState();
  const dispatch = useDispatch();
  const myProfile = useSelector((state) => state.auth.profile);
  const reservation_period = useSelector((state) => state.reservation.period);
  const reservation_guests = useSelector((state) => state.reservation.guests);
  const diffToUTC = useSelector((state) => state.time.diffToUTC);
  const currentProfile = useSelector((state) => state.auth.profile);
  const [descriptionShow, setDescriptionShow] = useState(false);

  const fee = useSelector((state) => state.reservation.fee);
  const feeBps =
    Number.isFinite(Number(fee)) && Number(fee) > 0
      ? Number(fee)
      : Number(process.env.REACT_APP_PLATFORM_FEE_BPS) || 300;
  const token = useSelector((state) => state.nft.nfts[params.id]);

  const mainnet = Mainnet();
  const getToken = async () => {
    if (!token) {
      try {
        const propertyData = await api("property/getProperty", {
          token_id: params.id,
        });
        if (propertyData) {
          dispatch(
            updateNFTStore({
              token_id: params.id,
              metaData: propertyData.metaData,
              short: propertyData.short,
              rentals: propertyData.rentals,
              access: propertyData.access,
              icalSync: propertyData.icalSync || null,
              manuallyBlockedDates: propertyData.manuallyBlockedDates || [],
            })
          );
        }
      } catch (error) {
        console.error("Failed to get property from backend:", error);
        await updateToken(
          {
            token_id: params.id,
            contract: process.env.REACT_APP_RENTAL_SMART_CONTRACT,
          },
          mainnet.endptTm,
          dispatch
        );
      }
    }
  };

  useEffect(() => {
    getToken();
  }, []);

  const [tryAfterConnect, setTryAfterConnect] = useState(false);
  const [txHash, setTxHash] = useState("");
  const [code, setCode] = useState();
  const account = useSelector((state) => state.auth.account);
  const [avgRate, setAvgRate] = useState();
  const [countReviews, setCountReviews] = useState();
  const [receipt, setReceipt] = useState();
  const wallet = useSelector((state) => state.auth.wallet);

  const getProfile = async (wallet) => {
    const profile = await api("profile/getProfile", {
      walletAddress: wallet,
    });
    setProfile(profile);
  };

  const getReview = async () => {
    const res = await api("review/get", {
      token_id: params.id,
    });
    if (!res) return;
    let avgRate = 0;
    for (let i = 0; i < res.length; i++) {
      avgRate += res[i].rate;
    }
    setAvgRate((avgRate / res.length).toFixed(1));
    setCountReviews(res.length);
  };

  useEffect(() => {
    if (params.id) getReview();
  }, [params.id]);

  useEffect(() => {
    getProfile(token?.access?.owner);
  }, [token]);

  // Preload property images for faster loading
  useEffect(() => {
    if (token) {
      imageOptimizationService.preloadPropertyImages(token);
    }
  }, [token]);

  const handleReserve = async () => {
    if (!account) {
      dispatch(setConnectModal(true));
      setTryAfterConnect(true);
      return;
    }

    // ✅ Check if user is verified before allowing reservation
    if (!myProfile?.isVerified) {
      toast.error("Please verify your identity before making a reservation. Complete KYC verification in your profile.", {
        autoClose: 5000
      });
      navigate("/dashboard/profile?mode=traveler");
      return;
    }
    // if (currentProfile?.ID === "" || !currentProfile?.ID) {
    //   toast.error("Please upload your profile to mint new NFT!");
    //   return;
    // }
    const message = {
      set_reservation_for_short_term: {
        token_id: params.id,
        renting_period: [
          (reservation_period.start + diffToUTC).toString(),
          (reservation_period.end + diffToUTC).toString(),
        ],
        guests: reservation_guests,
      },
    };

    // const message = {
    //   set_reservation_for_long_term: {
    //     token_id: params.id,
    //     renting_period: [
    //       (reservation_period.start + diffToUTC).toString(),
    //       (reservation_period.end + diffToUTC).toString(),
    //     ],
    //     guests: reservation_guests,
    //   },
    // };

    const currentTime = new Date(
      (Math.floor(new Date().getTime() / 1000) + diffToUTC) * 1000
    );

    const nights = Math.max(
      1,
      Math.round(
        (reservation_period.end - reservation_period.start) / 86400
      )
    );

    const hash = await executeRentalWithWallet({
      emailData: {
        name: myProfile.Name?.replace("/", " "),
        date:
          new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "numeric",
          }).format(new Date(reservation_period.start * 1000)) +
          "~" +
          new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "numeric",
          }).format(new Date(reservation_period.end * 1000)),
        checkin: token?.metaData.checkIn,
        checkout: token?.metaData.checkOut,
        image: token?.metaData.images[0],
        buildingName: token?.metaData.buildingName,
        price: (() => {
          const totalPrice = nights * token?.short.price_per_day;
          // Format to 2 decimal places, remove trailing zeros
          return parseFloat(totalPrice.toFixed(2)).toString();
        })(),
        detail: `https://test.codedestate.com/dashboard/traveler/trips/${
          params.id
        }?from=${(reservation_period.start + diffToUTC).toString()}&to=${(
          reservation_period.end + diffToUTC
        ).toString()}`,
        approved: token?.short?.auto_approve,
      },
      funds: {
        type: 1,
        amount: Math.round(
          nights * token?.short.price_per_day
        ).toString(),
      },
      currentTime,
      chainId: Mainnet().chainId,
      endpt: Mainnet().endptTm,
      contractAddr: process.env.REACT_APP_RENTAL_SMART_CONTRACT,
      dispatch,
      tokenId: params.id,
      receiver: token?.access.owner,
      CONTRACT_MESSAGE: message,
      account,
      walletType: wallet,
      walletEx: wallet,
      tokenToSend: [
        {
          amount: (
            nights * token?.short.price_per_day +
            (feeBps *
              (nights * token?.short.price_per_day)) /
              10000
          ).toString(),
          denom: process.env.REACT_APP_USDC_DENOM,
        },
      ],
    });
    if (hash) setTxHash(hash);
  };

  useEffect(() => {
    if (account === token?.access.owner) {
      toast.error("You cannot reserve your own property");
      navigate(-1);
    } else if (account && tryAfterConnect) handleReserve();
  }, [account]);

  const fetchCode = async (hash) => {
    const res = await getIdFromHash(hash);
    setCode(res);
  };

  useEffect(() => {
    if (txHash) fetchCode(txHash);
  }, [txHash]);

  return (
    <div className="w-full min-h-screen bg-gray-50">
      {!receipt && (
        <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 max-w-7xl">
          {/* <div className="flex items-center gap-[10px]">
            <div
              className="cursor-pointer text-[#A4A4A4]"
              onClick={() => navigate("/rent/all")}
            >
              Rent
            </div>
            <ArrowToRightIcon />
            <div className="text-[#A4A4A4]">Los Angeles, CA</div>
            <ArrowToRightIcon />

            <BlackButton text="Confirmation and pay" />
          </div> */}
          {!txHash && (
            <div
              onClick={() => navigate(-1)}
              className="cursor-pointer hover:bg-gray-50 rounded-2xl p-4 w-full bg-white shadow-lg mb-4 sm:mb-6"
            >
              <div className="flex gap-2 sm:gap-3 items-center">
                <ArrowToLeft />
                <div className="font-semibold text-lg sm:text-xl">
                  Confirmation and pay
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="mx-auto px-4 sm:px-6 lg:px-8 pb-8 max-w-7xl">
        {!txHash ? (
          <div className="flex flex-col lg:flex-row gap-4 sm:gap-6 lg:gap-8">
            {/* Left Panel - Trip Details */}
            <div className="w-full lg:w-3/5 xl:w-2/3">
              <Slide>
                <div className="bg-white p-4 sm:p-6 rounded-2xl shadow-lg space-y-4 sm:space-y-6">
                  <div className="text-lg sm:text-xl font-semibold">Your trip</div>
                  
                  {/* Dates and Guests */}
                  <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
                    <div className="flex-1 flex justify-between items-center">
                      <div className="flex items-center gap-2">
                        <CalendarIconRent />
                        <div className="text-sm sm:text-base">Dates</div>
                      </div>
                      <div className="text-gray-600 text-sm sm:text-base">
                        {new Date(
                          reservation_period.start * 1000
                        )?.toLocaleDateString("en-US", {
                          // year: "numeric",
                          month: "short",
                          day: "numeric",
                        }) +
                          "~" +
                          new Date(
                            reservation_period.end * 1000
                          )?.toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          })}
                      </div>
                    </div>
                    <div className="flex-1 flex justify-between items-center">
                      <div className="flex items-center gap-2">
                        <UserBoxIcon />
                        <div className="text-sm sm:text-base">Guest</div>
                      </div>
                      <div className="text-gray-600 text-sm sm:text-base">
                        {reservation_guests} guest
                      </div>
                    </div>
                  </div>
                  
                  <hr />
                  
                  {/* Payment Method */}
                  <div className="text-lg sm:text-xl font-semibold">Pay with</div>
                  <div className="w-full sm:w-4/5 flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 rounded-xl shadow-lg">
                    <div className="flex items-center gap-4 sm:gap-6">
                      <NUSDIcon />
                      <div className="text-sm sm:text-base">USDC</div>
                    </div>
                    <NumericFormat
                      value={
                        Math.round(
                          (reservation_period.end - reservation_period.start) /
                            86400
                        ) *
                          token?.short.price_per_day +
                        (feeBps *
                          (Math.round(
                            (reservation_period.end - reservation_period.start) /
                              86400
                          ) *
                            token?.short.price_per_day)) /
                          10000
                      }
                      thousandSeparator
                      decimalScale={2}
                      fixedDecimalScale={true}
                      displayType="text"
                      className="text-sm sm:text-base font-medium"
                    />
                  </div>
                  
                  <hr className="w-full sm:w-4/5" />
                  
                  {/* Host Messaging */}
                  <div className="text-base sm:text-lg font-medium">Message the host</div>
                  {/* <div className="text-gray-600 text-sm sm:text-base">
                    Share why you're traveling, who's coming with you, and what you
                    love about the space.
                  </div> */}
                  
                  <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                      {profile?.Avatar ? (
                        <img
                          alt="Avatar"
                          className="w-12 h-12 sm:w-14 sm:h-14 rounded-full"
                          src={profile?.Avatar}
                        />
                      ) : (
                        <Skeleton
                          width={56}
                          height={56}
                          style={{ borderRadius: "100px" }}
                        />
                      )}
                      <div>
                        <div className="text-sm sm:text-base font-medium">{profile?.Name?.replace("/", " ")}</div>
                        {/* <div className="text-gray-500 text-xs sm:text-sm">
                          {truncateWalletAddress(token?.access?.owner)}
                        </div> */}
                        <div className="text-gray-500 text-xs sm:text-sm font-thin">
                          Joined in{" "}
                          {profile?.created
                            ? new Date(profile?.created)?.toLocaleDateString(
                                "en-US",
                                {
                                  year: "numeric",
                                }
                              )
                            : ""}
                        </div>
                      </div>
                    </div>
                    <PurpleButton
                      text="Go to Inbox"
                      onClick={async () => {
                        let path = "";
                        const chat = await getChatId(
                          account,
                          token?.access.owner,
                          params.id,
                          "short"
                        );

                        path = "/dashboard/traveler/inbox";

                        if (chat) navigate(path + "?chat=" + chat);
                        else
                          navigate(
                            path +
                              `?id=${params.id}&receiver=${token?.access.owner}`
                          );
                      }}
                    />
                  </div>
                  
                  <hr />
                  
                  {/* Cancellation Policy */}
                  <div className="text-lg sm:text-xl font-semibold">
                    Cancellation policy
                  </div>
                  <div className="space-y-2">
                    <div className="text-sm sm:text-base">Free cancellation before approval.</div>
                    <div className="text-gray-600 text-sm sm:text-base">
                      Cancel before check-in on{" "}
                      {new Date(
                        reservation_period.start * 1000
                      )?.toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                      })}{" "}
                      for a partial refund.
                    </div>
                  </div>
                  
                  <div className="space-y-2">
                    {token?.short?.cancellation.map((item, index) =>
                      addDays(reservation_period.start * 1000, -item.deadline) >
                      new Date() ? (
                        <div key={index} className="text-sm sm:text-base">
                          {item.percentage} % refundable until{" "}
                          <b>
                            {addDays(
                              reservation_period.start * 1000,
                              -item.deadline
                            ).toLocaleDateString("en-US", {
                              month: "short",
                              day: "numeric",
                              year: "numeric",
                            })}
                          </b>
                        </div>
                      ) : (
                        <div key={index} className="text-sm sm:text-base">
                          {item.percentage} % refundable until{" "}
                          <b>
                            {addDays(
                              reservation_period.start * 1000,
                              -item.deadline
                            ).toLocaleDateString("en-US", {
                              month: "short",
                              day: "numeric",
                              year: "numeric",
                            })}
                          </b>
                          {/* <span className="ml-1">(not refundable)</span> */}
                        </div>
                      )
                    )}
                  </div>
                  
                  <hr />
                  
                  {/* Ground Rules */}
                  <div className="text-lg sm:text-xl font-semibold">Ground rules</div>
                  <div className="text-gray-600 text-sm sm:text-base">
                    We ask every guest to remember a few simple things about what
                    makes a great guest.
                  </div>
                  
                  <div className="space-y-3">
                    <div className="flex items-start gap-3">
                      <div className="w-2 h-2 rounded-full bg-gray-800 mt-2 flex-shrink-0"></div>
                      <div className="text-sm sm:text-base">Follow the house rules</div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-2 h-2 rounded-full bg-gray-800 mt-2 flex-shrink-0"></div>
                      <div className="text-sm sm:text-base">
                        Treat your Host's home like your own.
                      </div>
                    </div>
                  </div>
                  
                  <hr />
                  
                  {/* Reservation Notice */}
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-lg p-2 shadow-lg flex-shrink-0">
                      <ColoredCalender />
                    </div>
                    <div className="flex-1">
                      <div className="text-sm sm:text-base font-semibold">
                        Your reservation won't be confirmed until the Host accepts
                        your request (within 24 hours)
                      </div>
                      <div className="text-gray-600 text-sm sm:text-base mt-1">
                        You won't be charged until then
                      </div>
                    </div>
                  </div>
                </div>
              </Slide>
            </div>

            {/* Right Panel - Property & Pricing */}
            <div className="w-full lg:w-2/5 xl:w-1/3">
              <div className="bg-white p-4 sm:p-6 rounded-2xl shadow-lg space-y-4 sm:space-y-6">
                {/* Property Image */}
                <div className="bg-white p-2 rounded-2xl shadow-lg">
                  <PropertyImageWithFallback
                    src={token?.metaData.images[0]}
                    alt="Property"
                    className="w-full h-48 sm:h-56 lg:h-48 xl:h-56 rounded-xl object-cover"
                    priority={true}
                    lazy={false}
                    progressive={false}
                    width={800}
                    height={400}
                    quality={90}
                  />
                  {/* <RentalItem token_id={params.id} onlyImages /> */}
                  <div className="text-gray-500 text-sm sm:text-base mt-2">
                    {token?.metaData.buildingName}
                  </div>
                  <div className="text-gray-500 text-xs sm:text-sm truncate">
                    {token?.metaData.addressString}
                  </div>
                  {/* <div className="w-full flex justify-start my-2">
                    <BlackButton
                      text="Show Full description"
                      onClick={() => setDescriptionShow(true)}
                    />
                  </div> */}
                  
                  <Modal
                    open={descriptionShow}
                    onClose={() => setDescriptionShow(false)}
                    center
                    classNames={{
                      modal:
                        "min-w-[90vw] sm:min-w-[400px] rounded-xl border border-gray-200 shadow-xl",
                    }}
                  >
                    <div className="p-4 sm:p-6">
                      <div className="text-lg sm:text-xl font-bold mb-4">
                        Description
                      </div>
                      <div className="max-h-[50vh] overflow-auto text-sm sm:text-base">
                        {token?.metaData.description}
                      </div>
                    </div>
                  </Modal>
                  
                  <div className="flex items-center gap-2 mt-2">
                    <FavoriteIconRent />
                    <div className="text-sm sm:text-base">{avgRate}</div>
                    <div className="text-gray-500 text-xs sm:text-sm">
                      ({countReviews ? countReviews : "No"} reviews)
                    </div>
                  </div>
                </div>
                
                <PickDate />
                
                {/* Check-in/out Times */}
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <div className="flex items-center gap-2">
                      <CheckInIcon />
                      <div className="text-sm sm:text-base">Check in Hours</div>
                    </div>
                    <div className="text-gray-600 text-sm sm:text-base">
                      After {token?.metaData.checkIn}
                    </div>
                  </div>
                  
                  <div className="flex justify-between items-center">
                    <div className="flex items-center gap-2">
                      <CheckOutIcon />
                      <div className="text-sm sm:text-base">Check out Hours</div>
                    </div>
                    <div className="text-gray-600 text-sm sm:text-base">
                      After {token?.metaData.checkOut}
                    </div>
                  </div>
                </div>
                
                {/* Minimum Stay */}
                <div className="flex justify-between items-center">
                  <div className="font-semibold text-sm sm:text-base">Minimum Stay</div>
                  <div className="font-semibold text-sm sm:text-base">
                    {token?.short.minimum_stay} nights
                  </div>
                </div>
                
                {/* Pricing Breakdown */}
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <div className="text-gray-500 text-sm sm:text-base">Rent per day</div>
                    <div className="flex items-center gap-2">
                      <NUSDIcon />
                      <div className="text-sm sm:text-base">{token?.short.price_per_day} USDC</div>
                    </div>
                  </div>
                  
                  <hr />
                  
                  <div className="flex justify-between items-center">
                    <div className="text-gray-500 text-sm sm:text-base">Fee</div>
                    <div className="flex items-center gap-2">
                      <NUSDIcon />
                      <div className="text-sm sm:text-base">
                        {((feeBps *
                          (Math.round(
                            (reservation_period.end - reservation_period.start) /
                              86400
                          ) *
                            token?.short.price_per_day)) /
                          10000).toFixed(2)}{" "}
                        USDC
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex justify-between items-center">
                    <div className="text-gray-500 text-sm sm:text-base">Total payment</div>
                    <div className="flex items-center gap-2">
                      <NUSDIcon />
                      <div className="text-sm sm:text-base">
                        {(Math.round(
                          (reservation_period.end - reservation_period.start) /
                            86400
                        ) * token?.short.price_per_day).toFixed(2)}{" "}
                        USDC
                      </div>
                      <div className="text-xs text-gray-500">
                        /{" "}
                        {Math.round(
                          (reservation_period.end - reservation_period.start) /
                            86400
                        )}{" "}
                        days
                      </div>
                    </div>
                  </div>
                  
                  <hr />
                  
                  <div className="flex justify-between items-center">
                    <div className="font-semibold text-base sm:text-lg">Total (USDC)</div>
                    <div className="flex items-center gap-2">
                      <NUSDIcon />
                      <div className="text-purple-600 font-semibold text-lg sm:text-xl">
                        {(
                          Math.round(
                            (reservation_period.end - reservation_period.start) /
                              86400
                          ) *
                            token?.short.price_per_day +
                          (feeBps *
                            (Math.round(
                              (reservation_period.end - reservation_period.start) /
                                86400
                            ) *
                              token?.short.price_per_day)) /
                            10000
                        ).toFixed(2)}
                      </div>
                      <div className="text-sm sm:text-base">USDC</div>
                    </div>
                  </div>
                </div>
                
                {/* Action Buttons */}
                <div className="space-y-3">
                  <GreenButton
                    text={
                      <div className="flex items-center justify-center gap-2 text-sm sm:text-base">
                        Get USDC on Nibiru
                        <NibiruIcon />
                      </div>
                    }
                    onClick={() => window.open('https://express.noble.xyz/transfer?destination=nibiru', '_blank')}
                  />
                  
                  <PurpleButton
                    text={
                      <div className="text-center text-sm sm:text-base" onClick={handleReserve}>
                        Reserve Now
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            {receipt ? (
              <div className="max-w-2xl mx-auto">
                <div className="space-y-6 p-4 sm:p-6 rounded-2xl bg-white shadow-lg">
                  <Logo className="w-32 sm:w-40 mx-auto" />
                  
                  <div className="w-full flex items-center gap-3">
                    {token?.short?.auto_approve ? (
                      <>
                        <svg
                          className="w-8 h-8 sm:w-10 sm:h-10"
                          width="38"
                          height="38"
                          viewBox="0 0 38 38"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g filter="url(#filter0_d_672_36261)">
                            <rect
                              x="3"
                              y="3"
                              width="32"
                              height="32"
                              rx="16"
                              fill="#38A569"
                            />
                            <rect
                              x="3"
                              y="3"
                              width="32"
                              height="32"
                              rx="16"
                              fill="url(#paint0_linear_672_36261)"
                              fillOpacity="0.18"
                            />
                            <rect
                              x="3.25"
                              y="3.25"
                              width="31.5"
                              height="31.5"
                              rx="15.75"
                              stroke="white"
                              strokeOpacity="0.2"
                              strokeWidth="0.5"
                            />
                            <path
                              d="M25.5 15L17.5 23L13 18.5"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </g>
                          <defs>
                            <filter
                              id="filter0_d_672_36261"
                              x="0"
                              y="0"
                              width="38"
                              height="38"
                              filterUnits="userSpaceOnUse"
                              colorInterpolationFilters="sRGB"
                            >
                              <feFlood
                                floodOpacity="0"
                                result="BackgroundImageFix"
                              />
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              />
                              <feMorphology
                                radius="3"
                                operator="dilate"
                                in="SourceAlpha"
                                result="effect1_dropShadow_672_36261"
                              />
                              <feOffset />
                              <feComposite in2="hardAlpha" operator="out" />
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0.0784314 0 0 0 0 0.807843 0 0 0 0 0.326431 0 0 0 0.1 0"
                              />
                              <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_672_36261"
                              />
                              <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_672_36261"
                                result="shape"
                              />
                            </filter>
                            <linearGradient
                              id="paint0_linear_672_36261"
                              x1="19"
                              y1="3"
                              x2="19"
                              y2="23.6667"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop
                                offset="1"
                                stopColor="white"
                                stopOpacity="0"
                              />
                            </linearGradient>
                          </defs>
                        </svg>
                        <div className="text-base sm:text-lg font-semibold">
                          Your reservation is completed!
                        </div>
                      </>
                    ) : (
                      <>
                        <svg
                          className="w-8 h-8 sm:w-10 sm:h-10"
                          width="38"
                          height="38"
                          viewBox="0 0 38 38"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g filter="url(#filter0_d_672_36281)">
                            <rect
                              x="3"
                              y="3"
                              width="32"
                              height="32"
                              rx="16"
                              fill="#FFB300"
                            />
                            <rect
                              x="3"
                              y="3"
                              width="32"
                              height="32"
                              rx="16"
                              fill="url(#paint0_linear_672_36281)"
                              fillOpacity="0.18"
                            />
                            <rect
                              x="3.25"
                              y="3.25"
                              width="31.5"
                              height="31.5"
                              rx="15.75"
                              stroke="white"
                              strokeOpacity="0.2"
                              strokeWidth="0.5"
                            />
                            <path
                              d="M19 24.6201V28.0001"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M15.0206 22.98L12.6406 25.36"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M13.38 19H10"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M12.6406 12.6401L15.0206 15.0201"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M19 13V10"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M23.7695 14.2301L25.3595 12.6401"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M28 19H26.5"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M25.3607 25.3602L24.8307 24.8302"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </g>
                          <defs>
                            <filter
                              id="filter0_d_672_36281"
                              x="0"
                              y="0"
                              width="38"
                              height="38"
                              filterUnits="userSpaceOnUse"
                              colorInterpolationFilters="sRGB"
                            >
                              <feFlood
                                floodOpacity="0"
                                result="BackgroundImageFix"
                              />
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                              />
                              <feMorphology
                                radius="3"
                                operator="dilate"
                                in="SourceAlpha"
                                result="effect1_dropShadow_672_36281"
                              />
                              <feOffset />
                              <feComposite in2="hardAlpha" operator="out" />
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0.807843 0 0 0 0 0.603608 0 0 0 0 0.0784314 0 0 0 0.1 0"
                              />
                              <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_672_36281"
                              />
                              <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_672_36281"
                                result="shape"
                              />
                            </filter>
                            <linearGradient
                              id="paint0_linear_672_36281"
                              x1="19"
                              y1="3"
                              x2="19"
                              y2="23.6667"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="white" />
                              <stop
                                offset="1"
                                stopColor="white"
                                stopOpacity="0"
                              />
                            </linearGradient>
                          </defs>
                        </svg>
                        <div className="text-base sm:text-lg font-semibold">
                          Your reservation is requested
                        </div>
                      </>
                    )}
                  </div>
                  
                  <div className="w-full flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
                    <div className="text-sm sm:text-base">
                      <span>Hello</span>
                      <span className="font-semibold ml-1">
                        {myProfile?.Name?.replace("/", " ")}
                      </span>
                    </div>
                    <PurpleButton
                      text="See Status"
                      onClick={() => navigate("/dashboard/traveler/trips")}
                    />
                  </div>
                  
                  <div className="text-sm sm:text-base">
                    {token?.short?.auto_approve ? (
                      <div>Your reservation has been confirmed</div>
                    ) : (
                      <div>Your reservation has been requested to host</div>
                    )}
                  </div>

                 // <div className="text-sm sm:text-base font-semibold">
                   // Thank you for order with us!
                  //</div>
                  <div className="text-sm sm:text-base">CodedEstate Team</div>
                </div>
              </div>
            ) : (
              <>
                <div className="flex flex-col lg:flex-row gap-4 sm:gap-6 lg:gap-8">
                  <div className="w-full lg:w-3/5 xl:w-2/3">
                    <div className="bg-white p-4 sm:p-6 rounded-2xl shadow-lg space-y-4 sm:space-y-6">
                      <div className="flex items-center gap-3">
                        <div className="text-lg sm:text-xl font-semibold">
                          Your reservation is completed!
                        </div>
                        <div className="p-2 w-max rounded-full shadow-lg">
                          <CheckMarkIcon />
                        </div>
                      </div>
                      
                      <div className="text-gray-600 text-sm sm:text-base">
                        We emailed the details to Host
                      </div>
                      
                      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                        <div className="flex items-center gap-3">
                          <img
                            alt="Avatar"
                            src={profile?.Avatar}
                            className="w-10 h-10 sm:w-12 sm:h-12 rounded-full"
                          />
                          <div className="text-sm sm:text-base">{profile?.Name?.replace("/", " ")}</div>
                        </div>
                        <PurpleButton
                          text="Chat Now"
                          onClick={async () => {
                            let path = "";
                            const chat = await getChatId(
                              account,
                              token?.access.owner,
                              params.id,
                              "short"
                            );

                            path = "/dashboard/traveler/inbox";

                            if (chat) navigate(path + "?chat=" + chat);
                            else
                              navigate(
                                path +
                                  `?id=${params.id}&receiver=${token?.access.owner}`
                              );
                          }}
                        />
                      </div>
                      
                      <div className="space-y-3">
                        <div className="flex justify-between items-center">
                          <div className="flex items-center gap-2">
                            <BookingDateIcon />
                            <div className="font-semibold text-sm sm:text-base">Booking date</div>
                          </div>
                          <div className="text-gray-600 text-sm sm:text-base">
                            {new Date(
                              reservation_period.start * 1000
                            )?.toLocaleDateString("en-US", {
                              // year: "numeric",
                              month: "short",
                              day: "numeric",
                            }) +
                              "~" +
                              new Date(
                                reservation_period.end * 1000
                              )?.toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              })}
                          </div>
                        </div>
                        
                        <div className="flex justify-between items-center">
                          <div className="flex items-center gap-2">
                            <UsersIcon />
                            <div className="font-semibold text-sm sm:text-base">Guests</div>
                          </div>
                          <div className="text-gray-600 text-sm sm:text-base">
                            {reservation_guests} (
                            {converter.toWords(reservation_guests)})
                          </div>
                        </div>
                        
                        <div className="flex justify-between items-center">
                          <div className="flex items-center gap-2">
                            <CheckInIcon />
                            <div className="font-semibold text-sm sm:text-base">Check in Hours</div>
                          </div>
                          <div className="text-gray-600 text-sm sm:text-base">
                            After {token?.metaData.checkIn}
                          </div>
                        </div>
                        
                        <div className="flex justify-between items-center">
                          <div className="flex items-center gap-2">
                            <CheckOutIcon />
                            <div className="font-semibold text-sm sm:text-base">Check out Hours</div>
                          </div>
                          <div className="text-gray-600 text-sm sm:text-base">
                            Before {token?.metaData.checkOut}
                          </div>
                        </div>
                      </div>
                      
                      <hr />
                      
                      <div className="text-lg sm:text-xl font-semibold">Ground Rules</div>
                      <div className="text-sm sm:text-base">
                        We ask every guest to remember a few simple things about
                        what makes a great guest.
                      </div>
                      
                      <div className="space-y-4">
                        <div className="flex items-start gap-3">
                          <div className="mt-1 p-2 w-max rounded-full shadow-lg flex-shrink-0">
                            <div className="bg-purple-600 w-3 h-3 rounded-full"></div>
                          </div>
                          <div>
                            <div className="font-semibold text-sm sm:text-base">House rules</div>
                            <div className="text-sm sm:text-base">
                              Check-in after {token?.metaData.checkIn}
                            </div>
                            <div className="text-sm sm:text-base">
                              Checkout before {token?.metaData.checkOut}
                            </div>
                            <div className="text-sm sm:text-base">
                              {token?.metaData.groundRule}
                            </div>
                          </div>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <div className="mt-1 p-2 w-max rounded-full shadow-lg flex-shrink-0">
                            <div className="bg-purple-600 w-3 h-3 rounded-full"></div>
                          </div>
                          <div>
                            <div className="font-semibold text-sm sm:text-base">Safety & property</div>
                            <div className="text-sm sm:text-base">
                              Carbon monoxide alarm not reported
                            </div>
                            <div className="text-sm sm:text-base">
                              Smoke alarm not reported
                            </div>
                            <div className="text-sm sm:text-base">
                              Nearby lake, river, other body of water
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="w-full lg:w-2/5 xl:w-1/3">
                    <div className="bg-white p-4 sm:p-6 rounded-2xl shadow-lg space-y-4 sm:space-y-6">
                      <div className="bg-white space-y-2 p-2 rounded-2xl shadow-lg">
                        <PropertyImageWithFallback
                          src={token?.metaData.images[0]}
                          alt="Property"
                          className="w-full h-40 sm:h-48 rounded-xl object-cover"
                          priority={true}
                          lazy={false}
                          width={600}
                          height={300}
                          quality={85}
                        />
                        <div className="text-sm sm:text-base font-medium">{token?.metaData.buildingName}</div>
                        <div className="text-gray-500 text-xs sm:text-sm">
                          {new Date(
                            reservation_period.start * 1000
                          )?.toLocaleDateString("en-US", {
                            // year: "numeric",
                            month: "short",
                            day: "numeric",
                          }) +
                            "~" +
                            new Date(
                              reservation_period.end * 1000
                            )?.toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            })}
                        </div>
                        <div className="text-gray-500 text-xs sm:text-sm">
                          {token?.metaData.address.street +
                            ", " +
                            token?.metaData.address.city +
                            ", " +
                            token?.metaData.address.state}
                        </div>
                      </div>
                      
                      <div className="flex justify-between items-center">
                        <div className="text-gray-500 text-sm sm:text-base">Total</div>
                        <div className="flex items-center gap-2">
                          <NUSDIcon />
                          <div className="text-purple-600 font-semibold text-lg sm:text-xl">
                            {(Math.round(
                              (reservation_period.end - reservation_period.start) /
                                86400
                            ) *
                              token?.short.price_per_day +
                              (feeBps *
                                (Math.round(
                                  (reservation_period.end -
                                    reservation_period.start) /
                                    86400
                                ) *
                                  token?.short.price_per_day)) /
                                10000).toFixed(2)}
                          </div>
                          <div className="text-sm sm:text-base">USDC</div>
                        </div>
                      </div>
                      
                      <hr />
                      
                      <div className="space-y-3">
                        <div className="flex justify-between items-center">
                          <div className="text-gray-500 text-sm sm:text-base">
                            Transaction hash
                          </div>
                          <div className="flex items-center gap-2">
                            <CopyToClipboard
                              text={txHash}
                              onCopy={() => {
                                toast.success("Copied transaction hash");
                              }}
                            >
                              <div>
                                <CopyIcon className="cursor-pointer" />
                              </div>
                            </CopyToClipboard>
                            <div className="text-purple-600 text-xs sm:text-sm">
                              {truncateWalletAddress(txHash)}
                            </div>
                          </div>
                        </div>
                        
                        <div className="flex justify-between items-center">
                          <div className="text-gray-500 text-sm sm:text-base">
                            Reservation code
                          </div>
                          <div className="flex items-center gap-2">
                            <CopyToClipboard
                              text={String(code ?? "").toUpperCase().slice(-10)}
                              onCopy={() => {
                                toast.success("Copied reservation code");
                              }}
                            >
                              <div>
                                <CopyIcon className="cursor-pointer" />
                              </div>
                            </CopyToClipboard>
                            <div className="text-sm sm:text-base">{String(code ?? "").toUpperCase().slice(-10)}</div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="space-y-3">
                        <PurpleButton
                          text={<div className="w-full text-center text-sm sm:text-base">My Trip</div>}
                          onClick={() => navigate("/dashboard/traveler/trips")}
                        />
                        <BlackButton
                          onClick={() => setReceipt(true)}
                          text={<div className="w-full text-center text-sm sm:text-base">Receipt</div>}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

